import router from '../router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


var is_status = true

router.beforeEach((to, from, next) => {
  if(to.name){
    if (to.meta.webname){
      if (to.path === "/index") {
        next()
      } else if (to.path === "/shops") {
        if (!to.query.out) {
          next('/index')
        } else {
          let flag= JSON.stringify(sessionStorage.getItem('flag'))
          if (flag !== "null") {
            next()
          } else {
            next('/index')
          }

        }
      } else {
        next('/index')
      }
    }else{
      let permission = {}
      let role = JSON.parse(localStorage.getItem('role'));
      for (let k in role) {
        if (to.meta.pername == k) {
          permission = role[k]
        }
      }
      let token = localStorage.getItem('token');
      if (token) {
        if (to.path == '/merchant_admin' || to.path == '/dashboard') {
          next()
        } else {
          if (permission.read) {
            to.meta.permission = permission
            // 有权限能正常请求页面的情况下加载loading
            // 登陆页面与从详情返回不需要加载
            if (to.path != "/merchant_admin") {
              if (from.name != 'detail') {
                window.showLoading()
              }
            }
            next()
          } else {
            next('/dashboard')
          }
        }
      } else {
        
        if (to.path == '/merchant_admin' || to.path == '/dashboard') {
          next()
        } else {
          next('/index')
         /*  let fullPathUrl = localStorage.setItem('fullPathUrl', to.fullPath);
          next({
            path: '/merchant_admin',
            query: {
              fullPathUrl: to.fullPath
            }
          })*/
          // next('/merchant_admin?fullPathUrl' + to.fullPath)
        } 
      }
    }
  }else{
    next('/index')
  }
  
  
})
router.afterEach((to, from, next) => {

    window.hideLoading()
  
})

